import { Card, CardContent, CardMedia, Grid } from "@material-ui/core";
import { AccessTime } from "@material-ui/icons";
import { useHistory } from "../../hooks/useHistory";
import { useDispatch } from "react-redux";

import useStyles from "./contentCard.styles";
import { BookIcon, BookmarkIcon } from "../../icons";
import { formattedDate } from "../../formattedDate";
import { defaultContentImg } from "../../consts/imgUrls";
import { resetCurrentContent } from "../../../content/actions/contentActions";

interface ContentCardProps {
  imageUrl?: string;
  title: string;
  contentId: number;
  resourceType?: string;
  minutes: number;
  category?: string;
  createdAt?: string;
  isAssignedContent?: boolean;
  isBookmarked?: boolean;
  bookmarkContent?: (contentId: number, isBookmarked: boolean) => void;
}

export const ContentCard = ({
  imageUrl,
  title,
  contentId,
  resourceType,
  minutes,
  category,
  createdAt,
  isAssignedContent,
  isBookmarked,
  bookmarkContent,
}: ContentCardProps) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const history = useHistory();

  const onHandleClick = () => {
    dispatch(resetCurrentContent());

    history.push({
      pathname: `/participant/learning/${contentId}`,
      state: { isAssignedContent, learningDetails: true, from: contentId },
    });
  };

  const onBookmarkClicked = (event): void => {
    bookmarkContent?.(contentId, isBookmarked);
    event.stopPropagation();
  };

  return (
    <Card className={classes.card} onClick={onHandleClick}>
      <div>
        <CardMedia
          className={classes.media}
          image={imageUrl || defaultContentImg}
          title={title}
        />
        <CardContent className={classes.content}>
          <Grid container direction="column">
            {(category || createdAt) && (
              <Grid item className={classes.categoryCreatedContainer}>
                <div className={classes.category}>{category}</div>
                <div className={classes.created}>
                  {createdAt && formattedDate(createdAt)}
                </div>
              </Grid>
            )}
            <Grid item className={classes.title}>
              {title}
            </Grid>
            <Grid item className={classes.resourceTimeContainer}>
              <div className={classes.resourceType}>
                {resourceType && (
                  <>
                    <BookIcon className={classes.icon} />
                    {resourceType}
                  </>
                )}
              </div>
              <div className={classes.time}>
                <div>
                  {minutes > 0 && (
                    <>
                      <AccessTime className={classes.icon} />
                      {minutes} minute{minutes > 1 ? "s" : ""}
                    </>
                  )}
                </div>
                <div>
                  <BookmarkIcon
                    isBookmarked={isBookmarked}
                    onClick={onBookmarkClicked}
                  />
                </div>
              </div>
            </Grid>
          </Grid>
        </CardContent>
      </div>
    </Card>
  );
};
